// These constants match up with alert types to make showing alerts easier
// See: https://tools.hubteamqa.com/ui-library/show/UIComponents/alert/UIAlert/props-table
export const WARNING = 'warning';
export const ERROR = 'danger';